import axios from 'axios';

function getBaseUrl() {
    const configured = process.env.REACT_APP_API_BASE_URL;
    if (configured) return configured;
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
        return 'https://api.findmetrek.com/api';
    }
    return 'http://localhost:5000/api';
}

export const API_BASE_URL = getBaseUrl();

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 12000,
    withCredentials: true,
});

function safeGetLocalStorage(key) {
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch {
        return null;
    }
}

// Attach analytics consent header when calling analytics endpoint
apiClient.interceptors.request.use((config) => {
    try {
        const raw = safeGetLocalStorage('ftr_consent');
        if (raw) {
            const consent = JSON.parse(raw);
            if (config.url && config.url.includes('/analytics')) {
                config.headers = config.headers || {};
                config.headers['X-Analytics-Consent'] = consent.analytics ? 'true' : 'false';
            }
        }
    } catch (e) {
        // ignore
    }
    return config;
}, (err) => Promise.reject(err));

const retryStatuses = new Set([429]);
const maxRetries = 3;

apiClient.interceptors.response.use(
    response => response,
    async error => {
        const payload = error.response?.data;
        error.message = payload?.message || (error.code === 'ECONNABORTED'
            ? 'The request timed out. Please try again.'
            : error.message || 'Something went wrong.');
        error.status = error.response?.status;
        error.requestId = error.response?.headers?.['x-request-id'];

        const config = error.config;
        if (!config || !retryStatuses.has(error.response?.status)) {
            return Promise.reject(error);
        }
        config.__retryCount = (config.__retryCount || 0) + 1;
        if (config.__retryCount > maxRetries) {
            return Promise.reject(error);
        }
        const delay = Math.min(1000 * Math.pow(2, config.__retryCount - 1), 8000);
        await new Promise(resolve => setTimeout(resolve, delay));
        return apiClient(config);
    },
);

export default apiClient;
